import { render, staticRenderFns } from "./d2Tree.vue?vue&type=template&id=f2b4bfe6&scoped=true&"
import script from "./d2Tree.vue?vue&type=script&lang=js&"
export * from "./d2Tree.vue?vue&type=script&lang=js&"
import style0 from "./d2Tree.vue?vue&type=style&index=0&id=f2b4bfe6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b4bfe6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2b4bfe6')) {
      api.createRecord('f2b4bfe6', component.options)
    } else {
      api.reload('f2b4bfe6', component.options)
    }
    module.hot.accept("./d2Tree.vue?vue&type=template&id=f2b4bfe6&scoped=true&", function () {
      api.rerender('f2b4bfe6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rolePage/staff/comp/d2Tree.vue"
export default component.exports